// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3OMIy","containerItemsCenter":"Skeleton_containerItemsCenter__zVeP-"};